import React from 'react';

import WrapperWidget from '../Wrapper';
import Icon from '../../../Common/Icon';
import InputText from '../../../FormFields/Text';
import InputNumber from '../../../FormFields/Number';
import InputSelect from '../../../FormFields/Select';
import Checkbox from '../../../FormFields/Checkbox';
import DraggableList from '../../../Common/DraggableList';
import FieldOption from '../../../../Models/FieldOption';
import withConditionsAndTriggers from '../withConditionsAndTriggers';
import { SCORE_OPTIONS, TAGS_AVAILABLE, IS_ADMIN } from '../../../../Context/DynamicFormContext';
import ConfigService from "../../../../Services/api/Config";
import {ReactComponent as DeleteIcon} from "../../../../../img/icon-delete.svg";
import {ReactComponent as OpenIcon} from "../../../../../img/expand-closed.svg";
import {ReactComponent as DragIcon} from "../../../../../img/dform_dragndrop_icon.svg";
import TagSelect from '../../../Common/NewSelect';

export class SelectWidget extends React.PureComponent {

  onChangeOptions = (value, changeFieldValue, changeFieldError, options, index, attr) => {
    options[index][attr] = value;
    changeFieldValue('options', options);
    const error = this.checkLabelsValidation(options);
    changeFieldError('options', error);
  };

  checkLabelsValidation = (options) => {
    let result = '';
    options.forEach((option, index) => {
      if (!option.value) {
        result = 'All options should have some label.';
      }
      else {
        options.forEach((optionCompared, indexCompared) => {
           if (option.value.toLowerCase() === optionCompared.value.toLowerCase() && indexCompared !== index) {
            result = 'This field can not be repeated.';
          }
        });
      }
    });
    return result;
  };

  addConfigOption = (internalField, changeFieldValue) => {
    // Extract the number after "options#" and find the largest number
    const largestNumber = internalField.options.map(option => parseInt(option?.id?.split('#')[1])).reduce((max, current) => Math.max(max, current), -1);

    if(!isNaN(largestNumber)){
      // Add 1 to the largest number
      const nextOptionsNumber = 'options#'+ (largestNumber + 1);
      internalField.options.push(FieldOption.parse({ value: 'value new', score: undefined, lockDDR: false, id: nextOptionsNumber, componentId:internalField.id}));
    }else{
      internalField.options.push(FieldOption.parse({ value: 'value new', score: undefined, lockDDR: false}));
    }
    changeFieldValue('options', internalField.options);
  };

  removeConfigOption = (index, options, changeFieldValue, changeFieldError) => {
    options.splice(index, 1);
    changeFieldValue('options', options);
    const error = this.checkLabelsValidation(options);
    changeFieldError('options', error);
  };

  onDragSelectItem = (props, changeFieldValue, options) => {
    const { source, destination } = props;
    const item = options.splice(source.index, 1)[0];
    options.splice(destination.index, 0, item);
    changeFieldValue('options', options);
  };

  renderConfigOption = (option, index, internalField, changeFieldValue, changeFieldError) => {
    const { options, errors } = internalField;
    let tagTypeOptions=[];
    const getOptionValue = () => {
      if(internalField.updated_in_language &&  internalField[internalField.updated_in_language] && internalField[internalField.updated_in_language].options[index]){
        return internalField[internalField.updated_in_language].options[index].label;
      }
      else if(internalField.created_in_language && internalField[internalField.created_in_language.code] && internalField[internalField.created_in_language.code].options[index]){
        return internalField[internalField.created_in_language.code].options[index].label;
      }
      return option.value;
    }
    if(TAGS_AVAILABLE && TAGS_AVAILABLE.length>0){
       TAGS_AVAILABLE.forEach((item)=>{
         if(item.allow_use_in_dynamic_forms){
           tagTypeOptions.push({ value: item.id, label: item.display_name || item.tag_name, tag_name: item.tag_name});
         }
         if(!item.allow_use_in_dynamic_forms){
              if(option.tags_available && option.tags_available.length > 0){
               option.tags_available.filter((data , index)=>{
                   if(data== item.id){
                     option.tags_available.splice(index, 1);
                   }
               })
               }
        }
       })
    }
    return (
      <div className='Table' key={ index }>
        <div className="TableCell">
          <div className={'Draggable__Holder'}>
            <Icon width="15" height="15" color="tertiaryColor" position="Left">
              <DragIcon alt="value_dragndrop_icon" />
            </Icon>
          </div>
        </div>
        <div className='TableCell'>
          <InputText
            value={ getOptionValue() }
            onChange={ (v) => this.onChangeOptions(v, changeFieldValue, changeFieldError, options, index, 'value') }
            onError={ (error) => changeFieldError('options', error) }
            error={ errors['options'] }
            notShowErrors={ true }
            validators={ [(value) => this.checkLabelsValidation(options)] }
          />
        </div>
        <div className='TableCell'>
          <InputNumber value={ option.score }
                     onChange={ (v) => this.onChangeOptions(v, changeFieldValue, changeFieldError, options, index, 'score') }/>
        </div>
        <div className='TableCell Center'>
          <Checkbox onChange={ (v) => this.onChangeOptions(v, changeFieldValue, changeFieldError, options, index, 'lockDDR') } label=''
                    checked={ option.lockDDR }/>
        </div>
        <div className="TableCell">
          <TagSelect
            isMulti={true}
            onValueChange={(v)=> this.onChangeOptions(v, changeFieldValue, changeFieldError, options, index, 'tags_available')}
            value={option.tags_available}
            controlShouldRenderValue={false}
            showValuesContainer={false}
            availableTags={tagTypeOptions}
            isAdmin={IS_ADMIN}
          />
        </div>
        <div className='TableCell'>
          { options.length > 1 &&
            <Icon width='17' height='18' color='secondaryColor'
                  onClick={ () => this.removeConfigOption(index, options, changeFieldValue, changeFieldError) }>
              <DeleteIcon alt='icon-delete'/>
            </Icon>
          }
        </div>
      </div>
    );
  };

  renderConfigTab = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputText label='Description' value={ api.getFieldsVerbiage(internalField, 'description') }
                   onChange={ (v) => changeFieldValue('description', v) }/>
        <InputSelect label='Score type' value={ internalField.scoreType }
                   onChange={ (v) => changeFieldValue('scoreType', v) } options={ SCORE_OPTIONS }/>
        <div className='Widget_Form_Config_Options'>
          <div className='Table'>
            <div className='TableCell'>
            </div>
            <div className='TableCell'>
              <div className='InputWrapper-Label'>Value</div>
            </div>
            <div className='TableCell'>
              <div className='InputWrapper-Label'>Score</div>
            </div>
            <div className='TableCell'>
              <div className="InputWrapper-Label Center">Lock DDR</div>
            </div>
            <div className='TableCell'>
              <div className="InputWrapper-Label Center">Tag</div>
            </div>
            <div className='TableCell'>
            </div>
          </div>
          <DraggableList
            list={internalField.options}
            renderItem={(option, index) => this.renderConfigOption(option, index, internalField, changeFieldValue, changeFieldError)}
            onDragFinish={(props) => this.onDragSelectItem(props, changeFieldValue, internalField.options)}
          />
          { internalField.errors.options && (
            <div className='InputWrapper InputWrapper_Error'>
              <div className='InputWrapper-Error' style={ { color: ConfigService.getColor('errorColor') } }>
                { internalField.errors.options }
              </div>
            </div>
          ) }
        </div>
        <Icon className='Widget_Form_Config_Options_Add' width='15' height='15' color='secondaryColor'
              onClick={ () => { this.addConfigOption(internalField, changeFieldValue); } }>
          <OpenIcon alt='expand-closed'/>
        </Icon>
        <div className='InputCheckboxesWrapper'>
          <InputSelect label='Default Value' value={ internalField.defaultValue }
                     onChange={ (v) => changeFieldValue('defaultValue', v.value) }
                     options={ api ? api.getFieldsVerbiage(internalField, 'defaultOptions') : internalField.options.map((option) => {return { value: option.value, label: option.value };}) }/>

          <InputSelect label='Display Width' value={ internalField.display_width }
                              onChange={ (v) => changeFieldValue('display_width', v.value) }
                              options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                                return { value: option.value, label: option.value };
                              })} />
        </div>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('required', v) } label='Required'
                    checked={ internalField.required }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('photo', v) } label='Photo'
                    checked={ internalField.photo }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('notes', v) } label='Notes'
                    checked={ internalField.notes }
                    className='InputCheckbox_Block'/>
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, error, onChange, onError, api } = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'Select',
    }
    return (
      <WrapperWidget {...props}>
        <div className='SelectWidget'>
          <InputSelect
            disabled={ field.disabled }
            required={ field.required }
            options={ api ? api.getFieldsVerbiage(field, 'options') :  field.options.map((item, index) => { return { value: index, label: item.value }; }) }
            value={ value }
            onChange={ onChange }
            onError={ onError }
            error={error}
          />
        </div>
      </WrapperWidget>
    );
  }
}

export const SelectWidgetEditable = withConditionsAndTriggers(SelectWidget);